import { useState, useEffect } from "react";
import axios from "axios";
import { Clock } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LastUpdated = ({ page }) => {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchMeta = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/page-metadata/${page}`, {
          withCredentials: true,
        });
        if (!cancelled) setMeta(res.data);
      } catch {
        // silently ignore
      }
    };
    fetchMeta();
    return () => { cancelled = true; };
  }, [page]);

  if (!meta?.updated_at) return null;

  const date = new Date(meta.updated_at);
  const formatted = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground" data-testid="last-updated">
      <Clock className="w-3 h-3" />
      <span>Last updated on {formatted} by {meta.updated_by_name}</span>
    </div>
  );
};

export default LastUpdated;
